import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, UrlTree } from '@angular/router';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DoctorApiService } from '@core/services/doctor-api.service';
import { PublicDoctorProfileDto } from '@core/models/doctor.model';

@Injectable({ providedIn: 'root' })
export class DoctorProfileResolver implements Resolve<PublicDoctorProfileDto | UrlTree> {
  private readonly api = inject(DoctorApiService);
  private readonly router = inject(Router);

  public resolve(route: ActivatedRouteSnapshot): Observable<PublicDoctorProfileDto | UrlTree> {
    const id = route.paramMap.get('id');
    if (!id) {
      return of(this.router.createUrlTree(['/clinicians']));
    }
    return this.api.getPublicProfile(id).pipe(catchError(() => of(this.router.createUrlTree(['/clinicians']))));
  }
}
